// src/services/moduloServices.js
import { useApi } from './api';
import { URLS } from '../constants/urls';

export function useModuloService() {
  const { authenticatedFetch } = useApi();

  const criarModulo = async (dados) => {
    // dados: {
    //   idTrilha (hash),
    //   titulo,
    //   descricao?,
    //   ordem?,
    //   idTeste? (hash),
    //   miniTesteEstrutura?, // string ou objeto
    //   status: 'rascunho' | 'publicado' | 'inativo'
    // }
    const response = await authenticatedFetch(URLS.CREATE_MODULO, {
      method: 'POST',
      body: JSON.stringify(dados),
    });

    return response.json();
  };

  const atualizarModulo = async (dados) => {
    // dados: mesmo shape do create, mas com `id` (hash) obrigatório
    const response = await authenticatedFetch(URLS.UPDATE_MODULO, {
      method: 'POST',
      body: JSON.stringify(dados),
    });

    return response.json();
  };

  const deletarModulo = async (id) => {
    const response = await authenticatedFetch(URLS.DELETE_MODULO, {
      method: 'POST',
      body: JSON.stringify({ id }),
    });

    return response.json();
  };

  const listarModulos = async () => {
    // moduloRead.php não exige body, mas seguimos padrão POST com objeto vazio
    const response = await authenticatedFetch(URLS.READ_MODULO, {
      method: 'POST',
      body: JSON.stringify({}),
    });

    return response.json();
  };

  const obterModuloPorId = async (id) => {
    const response = await authenticatedFetch(URLS.READ_MODULO_BY_ID, {
      method: 'POST',
      body: JSON.stringify({ id }),
    });

    return response.json();
  };

  const listarModulosPorTrilha = async (idTrilha) => {
    // idTrilha: hash vindo da tela de trilha
    const response = await authenticatedFetch(URLS.READ_MODULO_BY_TRILHA, {
      method: 'POST',
      body: JSON.stringify({ idTrilha }),
    });

    return response.json();
  };

  return {
    criarModulo,
    atualizarModulo,
    deletarModulo,
    listarModulos,
    obterModuloPorId,
    listarModulosPorTrilha,
  };
}